<ul class="car__options">
  <li class="pb-1" *ngFor="let option of optionsInternal">
    <span class="car__options--name"
          *ngIf="option.name !== 'car.common.mileage.limitedMileage'">
      {{option.name | translate: option.params}}
    </span>

    <span class="car__options--name"
          *ngIf="option.name === 'car.common.mileage.limitedMileage'">
      {{option.name | translate:{ 
          allowance: option.params.allowance,
          unitOfMeasure: ('car.common.mileage.'+option.params.unitOfMeasure | translate | lowercase),
          rateType: (option.params.rateType | mileageType | translate | lowercase),
          extraMileageCharge: option.params.extraMileageCharge }
      }}
    </span>

    <span class="icon-info" 
          *ngIf="option.extra && option.name === 'car.common.mileage.limitedMileage'"
          matTooltipClass="box__tooltip"
          matTooltipPosition="above"
          matTooltip="{{option.extra | translate:{
            unitOfMeasure: ('car.common.mileage.'+option.params.unitOfMeasure | translate | lowercase),
            extraMileageCharge: option.params.extraMileageCharge | lowercase }
          }}"></span>
  </li>
</ul>
